/* product-addons.js — "Add-ons" on the PDP. Each add-on adds itself to the cart
   via /cart/add.js (independent of the main product form), updates Dawn's cart
   count bubble, and shows brief button feedback. Dependency-free. */
(function () {
  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var host = document.getElementById('cart-icon-bubble');
    if (!host) return;
    try {
      var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      // The returned section HTML wraps the bubble content; take the inner of the
      // .shopify-section wrapper (or #cart-icon-bubble / body as fallbacks).
      var wrap = doc.querySelector('.shopify-section') || doc.getElementById('cart-icon-bubble') || doc.body;
      if (wrap) host.innerHTML = wrap.innerHTML;
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (data) {
        updateBubble(data.sections);
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        // Let Dawn refresh any cart drawer/notification listeners if present.
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-addons' }); } catch (e) {}
        }
        setTimeout(function () { btn.textContent = original; btn.disabled = false; btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
  });
})();
